
import { homeDataConstants } from "../constants/HomeDataConstants";
import { homeDataService } from "../services/HomeDataService";

var prodCpy = {};

export const homeDataReducer = (state, action) => {

	switch (action.type) {




		case homeDataConstants.SHOW_MODAL:
			return {
				...state,
				previousReports: {
					showModal: true,
					id: action.data
				}

			};


		case homeDataConstants.HIDE_MODAL:
			return {
				...state,
				previousReports: {
					showModal: false,
					reports: [],
					id: "",
				}



			};




		case homeDataConstants.SHOW_ADD_MENU_MODAL:


			return {
				...state,
				id: action.data,
				showEditMenuModal: true

			};


		case homeDataConstants.HIDE_ADD_MENU_MODAL:
			return {
				...state,
				id: "",

				showEditMenuModal: false



			};











		case homeDataConstants.SHOW_ADD_MODAL:
			return {
				...state,
				showModal: true

			};


		case homeDataConstants.HIDE_ADD_MODAL:
			return {
				...state,
				showModal: false



			};




		case homeDataConstants.HIDE_EDIT_LOGO_MODAL:


			return {
				...state,

				showEditLogoModal: false,


			};

		case homeDataConstants.UPDATE_LOGO_PHOTO_SUCCESS:


			return {
				...state,

				showEditLogoModal: false,
				modalData: {
					success: true,
					failure: false,
					text: "You have successfully updated logo photo.",
				},

			};


		case homeDataConstants.HIDE_SUCCESS_FAILURE_MODAL:
			prodCpy = { ...state };

			prodCpy.updatePointData.show = false;
			prodCpy.modalData.success = false;
			prodCpy.modalData.failure = false;
			prodCpy.modalData.text = "";

			return prodCpy;


			

		case homeDataConstants.CLOSE_VIDEO:

		prodCpy = { ...state };

		console.log("akndhkafhksjdf")
		//prodCpy.modalData.success = true;
		//prodCpy.modalData.text = "You have successfully send a request for demo video";

		//prodCpy.loading = false
		prodCpy.video = null
		return prodCpy;

		case homeDataConstants.SEND_DEMO_SUCCESS:

			prodCpy = { ...state };

			//prodCpy.modalData.success = true;
			//prodCpy.modalData.text = "You have successfully send a request for demo video";

			//prodCpy.loading = false
			prodCpy.video = action.data.data
			prodCpy.tokens = action.data.tokens
			return prodCpy;

		case homeDataConstants.SEND_DEMO_LOADING_DONE:

			prodCpy = { ...state };

			//prodCpy.modalData.success = true;
			//prodCpy.modalData.text = "You have successfully send a request for demo video";
		
			console.log("evoo mee ovdeee sammm")
			prodCpy.loading = false
			prodCpy.modalVideo = true

			return prodCpy;

			case homeDataConstants.SEND_DEMO_LOADING_CLOSE:

			prodCpy = { ...state };

			//prodCpy.modalData.success = true;
			//prodCpy.modalData.text = "You have successfully send a request for demo video";

			prodCpy.modalVideo = false

			return prodCpy;

		case homeDataConstants.SEND_DEMO_FAILURE:

			prodCpy = { ...state };

			console.log(action)
			prodCpy.loading = false
			prodCpy.modalData.failure = true;
			prodCpy.modalData.text = action.data;
			return prodCpy;

		case homeDataConstants.SEND_DEMO_REQUEST:

			prodCpy = { ...state };

			
			prodCpy.video = null
			prodCpy.loading = true
			return prodCpy;

		case homeDataConstants.CHANGE_API_REQUEST:

			prodCpy = { ...state };


			prodCpy.loading = false
			return prodCpy;
		case homeDataConstants.SET_TOKENS:

			prodCpy = { ...state };

			prodCpy.tokens = action.tokens
			return prodCpy;

		case homeDataConstants.CHANGE_API_SUCCESS:

			prodCpy = { ...state };


			prodCpy.modalData.success = true;
			prodCpy.modalData.text = "Success";
			return prodCpy;

		case homeDataConstants.GET_VIDEOS_SUCCESS:

			prodCpy = { ...state };


			prodCpy.videos = action.data;
			return prodCpy;

		case homeDataConstants.GET_FAMOUS_PEOPLE_REQUEST:

			prodCpy = { ...state };


			prodCpy.loadingStory = true;
			return prodCpy;

		case homeDataConstants.GET_FAMOUS_PEOPLE_SUCCESS:

			prodCpy = { ...state };


			prodCpy.famouspeople = action.data;
			prodCpy.loadingStory = false;
			return prodCpy;

		case homeDataConstants.GET_STORY_SUCCESS:

			prodCpy = { ...state };

			console.log(action.data)
			prodCpy.story = [...prodCpy.story, action.data.story];
			prodCpy.conversation_history = action.data.conversation_history;
			prodCpy.part = action.data.part;
			prodCpy.ready = true;

			return prodCpy;

		case homeDataConstants.GET_CREATE_TOUR_VIDEO_SUCCESS:

			prodCpy = { ...state };

			prodCpy.tourVideo = action.data;

			return prodCpy;

			case homeDataConstants.LOADING_START:

			prodCpy = { ...state };

			prodCpy.loadingStory1 = true;
			prodCpy.story = [];
			prodCpy.conversation_history = ""

			prodCpy.ready = true;


			return prodCpy;

			case homeDataConstants.LOADING_END:

			prodCpy = { ...state };
			prodCpy.loadingStory1 = false;

			return prodCpy;
		case homeDataConstants.GET_STORY_REQUEST:

			prodCpy = { ...state };


			return prodCpy;

		case homeDataConstants.GET_POIS_SUCCESS:

			prodCpy = { ...state };

			prodCpy.locations = action.data;
			prodCpy.loadingStory = false;

			return prodCpy;

		case homeDataConstants.GET_TOUR_LIBRARY_SUCCESS:

			prodCpy = { ...state };

			prodCpy.tourLibrary = action.data;

			return prodCpy;

		case homeDataConstants.GET_POIS_REQUEST:

			prodCpy = { ...state };

			prodCpy.loadingStory = true;

			return prodCpy;

		case homeDataConstants.GO_BACK:

			prodCpy = { ...state };


			prodCpy.ready = false;

			return prodCpy;

		case homeDataConstants.TOGGLE_EDIT:
			return {
				...state,
				editIndex: state.editIndex === action.payload ? null : action.payload,
			};
		case homeDataConstants.UPDATE_LOCATION:
			const updatedLocations = [...state.locations];
			updatedLocations[action.payload.index] = action.payload.value;
			return { ...state, locations: updatedLocations, editIndex: null };


		case homeDataConstants.START_DRAG:
			return { ...state, draggedIndex: action.payload };
		case homeDataConstants.END_DRAG:
			const { draggedIndex, overIndex } = action.payload;
			if (draggedIndex !== overIndex) {
				const newLocations = [...state.locations];
				const item = newLocations.splice(draggedIndex, 1)[0];
				newLocations.splice(overIndex, 0, item);
				return { ...state, locations: newLocations, draggedIndex: null };
			}
			return { ...state, draggedIndex: null };


		case homeDataConstants.GET_ADDS_SUCCESS:

			prodCpy = { ...state };

			prodCpy.adds = action.data;
			prodCpy.loading = false;

			return prodCpy;

		case homeDataConstants.GET_ADDS_REQUEST:

			prodCpy = { ...state };

			prodCpy.loading = true;

			return prodCpy;

		case homeDataConstants.GET_PATMENT_LINK_SUCCESS:

			prodCpy = { ...state };

			console.log(action.data)
			window.location.href = action.data;
			prodCpy.loading = false;

			return prodCpy;

		case homeDataConstants.GET_PATMENT_LINK_REQUEST:

			prodCpy = { ...state };

			prodCpy.loading = true;

			return prodCpy;

		case homeDataConstants.UPDATE_STORY_CHAPTER:
			const updatedStory = [...state.story];
			updatedStory[action.payload.index] = action.payload.newDescription;
			return { ...state, story: updatedStory };



			
		case homeDataConstants.GET_PROMPT_REQUEST:

		prodCpy = { ...state };
		prodCpy.loading = true;

		return prodCpy;

				
		case homeDataConstants.GET_PROMPT_SUCCESS:


		console.log(action.data)
		prodCpy = { ...state };
		prodCpy.loading = false;
		prodCpy.promptResult = action.data.response;
		

		return prodCpy;

		
				
		case homeDataConstants.GET_PROMPT_FAILURE:

		prodCpy = { ...state };
		prodCpy.loading = false;

		return prodCpy;

		
		default:
			return state;
	}
};
